import React from 'react';
import { Facebook, Instagram, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#111111] text-white pt-20 pb-8" data-id="element-11">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 text-center md:text-left" data-id="element-13">
          {/* Brand Column */}
          <div className="flex flex-col items-center md:items-start" data-id="element-14">
            <a href="#" className="font-heading font-bold text-3xl text-brand mb-6 block" data-id="element-15">
              Cool Lawns
            </a>
            <p className="text-gray-400 mb-6 max-w-xs" data-id="element-16">
              Denton's trusted local landscaping and hardscaping experts. We
              make your yard the best on the block.
            </p>
            <div className="flex space-x-4" data-id="element-17">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand transition-colors" aria-label="Facebook" data-id="element-18">
                <Facebook size={20} data-id="element-19" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand transition-colors" aria-label="Instagram" data-id="element-20">
                <Instagram size={20} data-id="element-21" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand transition-colors" aria-label="Google" data-id="element-22">
                <MapPin size={20} data-id="element-23" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-24">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-25">Company</h4>
            <ul className="space-y-4 text-gray-400" data-id="element-26">
              <li data-id="element-27">
                <a href="#about" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-28">
                  About Us
                </a>
              </li>
              <li data-id="element-29">
                <a href="#services" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-30">
                  Services
                </a>
              </li>
              <li data-id="element-31">
                <a href="#work" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-32">
                  Our Work
                </a>
              </li>
              <li data-id="element-33">
                <a href="#contact" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-34">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Services Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-35">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-36">Services</h4>
            <ul className="space-y-4 text-gray-400" data-id="element-37">
              <li data-id="element-38">
                <a href="#" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-39">
                  Lawn Care
                </a>
              </li>
              <li data-id="element-40">
                <a href="#" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-41">
                  Landscaping
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-43">
                  Hardscaping
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-45">
                  Drainage
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-47">
                  Irrigation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center md:items-start" data-id="element-48">
            <h4 className="font-heading font-bold text-lg mb-6" data-id="element-49">Contact</h4>
            <ul className="space-y-4 text-gray-400" data-id="element-50">
              <li data-id="element-51">
                <a href="tel:555-123-4567" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-52">
                  (555) 123-4567
                </a>
              </li>
              <li data-id="element-53">
                <a href="mailto:hello@coollawns.com" className="hover:text-brand transition-colors min-h-[44px] inline-flex items-center" data-id="element-54">
                  hello@coollawns.com
                </a>
              </li>
              <li className="pt-2" data-id="element-55">
                Denton, TX
                <br data-id="element-56" />
                Serving Denton County
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm space-y-4 md:space-y-0 text-center md:text-left" data-id="element-57">
          <p data-id="element-58">© 2026 Cool Lawns. All rights reserved.</p>
          <p data-id="element-59">Managed by LetLois</p>
        </div>
      </div>
    </footer>;
}